// extracted by mini-css-extract-plugin
export default {"app":"App_app__zr1wm","pageContent":"App_pageContent__S6r43"};